// extracted by mini-css-extract-plugin
module.exports = {"seperator":"Seperator_seperator__14S6Y"};